import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'

import { history } from "../../store";
import { getTypSubmittedForVerificationAPI, getVisitReportAPI,  } from '../../../services/typist-service';
import { FETCH_SUBMITTED_FOR_VERIFICATION_VISITS, FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR, FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START, FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS, LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START, LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START, VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION, SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT } from '../../actions/typist/typistSubmittedAction';
import { fetchRadiologistTemplates } from '../../actions/typist/typistWorklistAction';
import { lockVisitAPI } from '../../../services/locked-visits-service';
import { SET_VISIT_LOCK } from '../../actions/activityAction';
const getAuthUserState = (state) => state.auth.authUser;
const getRoutingLocation = (state) => state.routing.location;
// const getRisUsersState = (state) => state.auth.authUser.risUserMips;

// function* getRisUserNameForRisId(risId) {
//     try {
//         const risUsers = yield select(getRisUsersState);
//         if (risUsers.length > 0) {
//             const risUser = risUsers.find(user => user.risId === risId);
//             if (risUser) {
//                 return risUser.userName;
//             }
//             message.error("Ris user not found for ris id:" + risId);
//             return null;
//         }
//         message.error("Ris users not found!");
//         return null;
//     } catch (error) {
//         console.log(error);
//     }
// }

function* setVisitLock(visit) {

    if (visit !== null) {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: true,
                reportId: visit.reportId
            }
        })
    } else {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: false,
                reportId: null
            }
        })
    }
}

function* fetchSubmittedVisits({ payload }) {
    try {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START })
        const response = yield call(getTypSubmittedForVerificationAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS, visits: response.data.typSfvVisits });
            yield put({ type: SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION, pagination });
            yield put({ type: SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT, payload: { ...payload } });
        } else {
            if (response.error) {
                yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR, error: response.error })
                message.error('Failed to fetch submitted visits!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR, error })
        message.error('Failed to fetch submitted visits!');
    }
}

function* viewSubmittedVisit({ visit }) {
    try {
        // const risUserName = yield getRisUserNameForRisId(visit.risId);
        const { userId } = yield select(getAuthUserState);
        if (visit.lockedBy === null) {
            yield put({ type: LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START });
            const response = yield call(lockVisitAPI, visit.reportId);
            if (response.success) {
                yield put({ type: LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, visit: { ...visit, ...response.response } });
                yield call(viewVisit, { ...visit, ...response.response });
                if (visit) {
                    yield call(setVisitLock, visit);
                }
            } else {
                if (response.error) {
                    yield put({ type: LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: response.error })
                    message.error(response.error);
                } else {
                    yield put({ type: LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: null })
                    message.error('Failed to view visit!');
                }
                yield call(setVisitLock, null);
            }
        } else {
            if (userId === visit.lockedBy) {
                if (visit && visit.lockedBy !== null) {
                    yield call(setVisitLock, visit);
                }
                yield call(viewVisit, visit);
            } else {
                message.error('Visit is already locked by other user!');
            }
        }
    } catch (error) {
        yield put({ type: LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error })
        yield call(setVisitLock, null);
        message.error('Failed to view visit!');
    }
}

function* viewVisit(visit) {
    yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START })
    const { pathname } = yield select(getRoutingLocation);
    const response = yield call(getVisitReportAPI, visit.risId, visit.reportId, visit.visitNo);
    if (response.success) {
        yield put({
            type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
            report: {
                ...response.visitReport
            }
        });
        // yield put(fetchRadiologistTemplates(visit.radiologistCode));
        history.push({
            pathname: '/typ/report-editor',
            state: {
                from: pathname
            }
        });
    } else {
        if (response.error) {
            yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: response.error })
            message.error(response.error);
        } else {
            yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error: response.error })
            message.error('Failed to view visit!');
        }
    }
}

function* typistSubmittedWatcher() {
    yield takeEvery(FETCH_SUBMITTED_FOR_VERIFICATION_VISITS, fetchSubmittedVisits)
    yield takeLatest(VIEW_SUBMITTED_FOR_VERIFICATION_VISIT, viewSubmittedVisit)
}

export default function* rootSaga() {
    yield all([
        typistSubmittedWatcher(),
    ]);
}